"use client";

import React from "react";
import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { PostsProvider, usePosts } from "@/integrations/wordpress/WordPressPostsProvider";
import { WP_Query } from "@/integrations/wordpress/wp_query";
function PostsGridConsumer() {
  const {
    posts,
    loading,
    error
  } = usePosts();
  if (loading) {
    return <div data-section-id="109532" className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3">
        {[...Array(3)].map((_, i) => <Card key={i} data-index={i} className="overflow-hidden border-none shadow-xl bg-card/50">
            <AspectRatio ratio={16 / 9} className="bg-muted/20 animate-pulse" />
            <CardContent className="p-6">
              <div className="mb-3 h-6 w-3/4 animate-pulse rounded bg-muted/20" />
              <div className="mb-2 h-4 w-full animate-pulse rounded bg-muted/10" />
              <div className="h-4 w-2/3 animate-pulse rounded bg-muted/10" />
            </CardContent>
          </Card>)}
      </div>;
  }
  if (error) {
    return <div className="text-center text-sm text-muted-foreground py-12">
        <p>Unable to load compliance resources at this time.</p>
      </div>;
  }
  if (posts.length === 0) {
    return <div className="text-center text-sm text-muted-foreground py-12">
        <p>No compliance updates published yet. Check back soon.</p>
      </div>;
  }
  return <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3">
      {posts.map((post, i) => <Card key={post.id} data-index={i} className="group overflow-hidden border border-border/10 shadow-xl transition-all duration-300 hover:shadow-2xl hover:shadow-primary/10 bg-card">
          <Link to={post.link || "#"} className="relative block overflow-hidden">
            <AspectRatio ratio={16 / 9} className="overflow-hidden bg-muted after:absolute after:inset-0 after:bg-primary/5 after:transition-opacity group-hover:after:opacity-0">
              {post.featuredImage ? <img src={post.featuredImage} alt={post.title} className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-110" /> : <div className="flex h-full w-full items-center justify-center bg-primary/10 text-primary/40">
                  <span className="font-sans text-lg font-bold tracking-widest opacity-50 uppercase">Cannabis Cloud</span>
                </div>}
            </AspectRatio>
          </Link>
          <CardContent className="p-6">
            <Link to={post.link || "#"} className="block group-hover:text-primary transition-colors">
              <h3 className="mb-3 font-sans text-xl font-bold leading-tight line-clamp-2 text-foreground tracking-tight">
                {post.title}
              </h3>
            </Link>
            {post.excerpt && <div className="mb-4 text-sm text-muted-foreground line-clamp-3 font-sans leading-relaxed" dangerouslySetInnerHTML={{
          __html: post.excerpt
        }} />}
            <Link to={post.link || "#"} className="inline-flex items-center text-sm font-semibold text-primary group/link">
              Read Strategy <ArrowRight className="ml-1.5 h-4 w-4 transition-transform duration-300 group-hover/link:translate-x-1" />
            </Link>
          </CardContent>
        </Card>)}
    </div>;
}
export default function LatestLegalInsights() {
  const wp_query_params = {
    per_page: 3,
    order: "desc",
    orderby: "date"
  };
  const wp_query = new WP_Query(wp_query_params);
  return <section id="the-compliance-hub" className="bg-background dark py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-8">
        <div className="mb-12 text-center">
          <h2 className="font-sans text-3xl font-bold tracking-tighter text-foreground md:text-5xl lg:text-6xl">
            The Compliance Hub
          </h2>
          <p className="mt-6 text-muted-foreground font-sans text-lg md:text-xl max-w-3xl mx-auto leading-relaxed">
            Master the complexities of regulated cannabis operations with our latest industry insights, Metrc integration strategies, and technical guides.
          </p>
        </div>

        <PostsProvider wp_query={{
        per_page: 3,
        order: "desc",
        orderby: "date"
      }}>
          <PostsGridConsumer />
        </PostsProvider>

        <div className="mt-12 flex justify-center">
          <Link to="#">
            <Button variant="outline" size="lg" className="rounded-xl border-primary/20 text-primary hover:bg-primary/10 px-10 font-sans font-semibold transition-all duration-300">
              Explore All Resources
            </Button>
          </Link>
        </div>
      </div>
    </section>;
}